module.exports = __webpack_public_path__ + "img/espanha-flag.d51907b3.png";